import"./DynamicSvg.css.ts.vanilla.css";var i="_15gj9s20",r="_15gj9s21";export{i as dynamicSvgContainer,r as fillStyle};
